/* Mixed variant pickers — Simply Carbon Fiber's own file (2026-09-11). The Variant picker block's
   "Options shown as a dropdown" setting lets one option be a <select> while the others stay
   buttons/swatches. Impulse's theme.VariantAvailability reads a single picker type from the first
   option wrapper and applies it to every group, which throws on a mixed form. This makes the
   per-group methods use each group's own wrapper type instead. Loaded before theme.js and hooks
   the class the moment theme.js assigns it (sections are created synchronously at the end of theme.js). */
(function () {
  if (typeof window === 'undefined') return;
  function patch(VA) {
    if (!VA || !VA.prototype || VA.prototype.__mixed) return VA;
    var proto = VA.prototype; proto.__mixed = true;
    ['disableVariantGroup', 'enableVariantOption'].forEach(function (name) {
      var orig = proto[name];
      if (typeof orig !== 'function') return;
      proto[name] = function (group) {
        var wrapper = group && group.closest ? group.closest('.variant-wrapper') : null;
        var saved = this.type;
        if (wrapper && wrapper.dataset.type) this.type = wrapper.dataset.type;
        try { return orig.apply(this, arguments); } finally { this.type = saved; }
      };
    });
    return VA;
  }
  window.theme = window.theme || {};
  if (theme.VariantAvailability) { patch(theme.VariantAvailability); return; }
  var stored;
  Object.defineProperty(theme, 'VariantAvailability', {
    configurable: true, enumerable: true,
    get: function () { return stored; },
    set: function (v) { stored = patch(v); }
  });
})();
